import { useLazyGetQuestionsByCompanyIdQuery } from '../../features/apis/intergration';
import useCurrentUser from '../../customHook/useCurrentUser';
import { useEffect } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  AccordionIcon,
} from '@chakra-ui/react';

export function QuestionaireTab() {
  const user = useCurrentUser();
  const [getQuestionsByCompanyId, { data: questionsData }] =
    useLazyGetQuestionsByCompanyIdQuery();

  useEffect(() => {
    if (user?.companyId) {
      getQuestionsByCompanyId(user.companyId).unwrap();
    }
  }, [getQuestionsByCompanyId, user?.companyId]);

  return (
    <Box className="w-full flex flex-col gap-4">
      <Box className="w-full">
        <p className="text-gray-700 text-sm">
          Screening questions sent to applicants
        </p>
      </Box>

      <Accordion allowMultiple className="w-full">
        {questionsData?.map((job: any, index: number) => (
          <AccordionItem
            key={index}
            className="border-[#D4D4D4] border-[0.5px] rounded-lg mb-2 w-full"
          >
            <h2>
              <AccordionButton className="px-4 py-3">
                <Box
                  flex="1"
                  textAlign="left"
                  className="font-medium text-gray-800"
                >
                  {job.jobTitle}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>

            {/* Accordion Content */}
            <AccordionPanel pb={4} className="space-y-3 w-full">
              {job.questions?.length > 0 ? (
                job.questions.map((q: string, i: number) => (
                  <Box
                    key={i}
                    className="flex items-center gap-3 p-3  border-[#D4D4D4] border-[0.5px] rounded-md w-full"
                  >
                    <Box className="w-6 h-6 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-xs font-bold  flex-shrink-0">
                      {i + 1}
                    </Box>
                    <Box
                      className="text-gray-700 text-sm flex-1 w-full"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >
                      {q}
                    </Box>
                  </Box>
                ))
              ) : (
                <Box className="text-gray-400 text-sm w-full">
                  No questions added
                </Box>
              )}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
}
